import { SxProps, Theme } from "@mui/material/styles";
import theme from "../../../../theme";

const styles: SxProps<Theme> = [
  {
    "&.container": {
      padding: "62px 12px",
      margin: "auto",
      maxWidth: 880,
      textAlign: "center",
      "& h2": {
        fontSize: 26,
        margin: 0,
      },
      "& h3": {
        textTransform: "initial",
        fontSize: 14,
        color: "#808080",
      },
    },
    "& .divider": {
      height: 2,
      background: theme.palette.primary.main,
      width: 100,
      margin: "24px auto",
    },
    "& .containerFonctions": {
      display: "flex",
      flexWrap: "wrap",
    },
    "& .fonction": {
      border: "2px solid " + theme.palette.primary.main,
      padding: "16px",
      width: "calc(50% - 16px)",
      marginBottom: "32px",
      "&:nth-child(odd)": {
        marginRight: "16px",
      },
      "&:nth-child(even)": {
        marginLeft: "16px",
      },
      "& p": {
        fontSize: 20,
        fontWeight: "500",
        margin: 0,
      },
      "& span": {
        fontSize: 16,
      },
    },
    "@media all and (max-width: 580px)": {
      "& .containerFonctions": {
        display: "block",
      },
      "& .fonction": {
        width: "98%",
        "&:nth-child(odd)": {
          marginRight: 0,
        },
        "&:nth-child(even)": {
          marginLeft: 0,
        },
      },
    },
  },
];

export default styles;
